import { render, staticRenderFns } from "./InvoiceType.vue?vue&type=template&id=9f21ed72&scoped=true&"
import script from "./InvoiceType.vue?vue&type=script&lang=js&"
export * from "./InvoiceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f21ed72",
  null
  
)

export default component.exports